module.exports = __webpack_public_path__ + "afd95955bd11676806b7662ee53a0d61.png";